import { render, staticRenderFns } from "./CardPrepProduction.vue?vue&type=template&id=04847ad6&scoped=true"
import script from "./CardPrepProduction.vue?vue&type=script&lang=js"
export * from "./CardPrepProduction.vue?vue&type=script&lang=js"
import style0 from "./CardPrepProduction.vue?vue&type=style&index=0&id=04847ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04847ad6",
  null
  
)

export default component.exports